import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="ai-footer">
    <div className="ai-wrap">
      <div>
        <Link to="/" className="ai-wordmark">
          <span className="ai-mark" aria-hidden="true" />
          <span>Afterimage <small>Labs</small></span>
        </Link>
        <p>We read medical records and report where a diagnosis was missed or delayed.</p>
      </div>
      <nav aria-label="Footer">
        <Link to="/mission">Mission</Link>
        <Link to="/impact">Impact</Link>
        <Link to="/careers">Get involved</Link>
      </nav>
      <p className="legal">&copy; {new Date().getFullYear()} Afterimage Labs</p>
    </div>
  </footer>
);

export default Footer;
